import { AISuggestionsMatcher } from '@/modules/aiSuggestions/AISuggestionsMatcher/AISuggestionsMatcher';
import { AISuggestionArrayFieldDuplicates } from '@/modules/aiSuggestions/components/AISuggestionArrayFieldDuplicates';
import { useSuggestionAcknowledgementContext } from '@/modules/aiSuggestions/context/SuggestionAcknowledgement.context';
import { useTestamentaryEntitySuggestionsContextIfAvailable } from '@/modules/aiSuggestions/context/TestamentaryEntitySuggestions.context';
import { useFeatureFlag } from '@/modules/featureFlags/useFeatureFlag';

import { useEditTestamentaryEntitySplitScreenModalContext } from '../contexts/editTestamentaryEntitySplitScreenModal.context';
import { getMatcherVariantForEditTestamentaryEntitySection } from '../EditTestamentaryEntitySplitScreen.utils';

/**
 * Renders AI suggestions matcher for the current section of the testamentary entity form.
 * This component should be rendered within the TestamentaryEntitySuggestionsProvider.
 */
export function EditTestamentaryEntitySplitScreenFormSuggestionsMatcher() {
  const subtrustAISuggestionsEnabled = useFeatureFlag(
    'aikg_v2_associations_poc'
  );
  const { currentSection } = useEditTestamentaryEntitySplitScreenModalContext();

  // Use the "if available" hook since the provider may not be present when the flag is off
  const suggestionsContext =
    useTestamentaryEntitySuggestionsContextIfAvailable();
  const { acknowledgedSuggestions } = useSuggestionAcknowledgementContext();

  const suggestionsMatcherVariant =
    getMatcherVariantForEditTestamentaryEntitySection(currentSection);

  // Don't render if:
  // - Feature flag is disabled
  // - No variant for this section (e.g., BASIC_INFORMATION, DISPOSITIONS)
  // - Context not available
  if (
    !subtrustAISuggestionsEnabled ||
    !suggestionsMatcherVariant ||
    !suggestionsContext
  ) {
    return null;
  }

  const { getCurrentSectionSuggestions } = suggestionsContext;

  // Filter out acknowledged suggestions
  const suggestions = getCurrentSectionSuggestions(currentSection).filter(
    (s) => !acknowledgedSuggestions[s.id]
  );

  // Don't render the matcher if there are no suggestions
  if (suggestions.length === 0) {
    return null;
  }

  return (
    <>
      <AISuggestionsMatcher
        variant={suggestionsMatcherVariant}
        suggestions={suggestions}
      />
      <AISuggestionArrayFieldDuplicates />
    </>
  );
}
